import { App } from 'vue';
import ModalBox from './ModalBox.vue';
import { params } from './params';
import { ModalBoxPluginOptions } from './types';

export function install(app: App, args: ModalBoxPluginOptions = {}): void {
    Object.entries(args).forEach((entry) => params.set(...entry));
    app.component(args.componentName || 'ModalBox', ModalBox);
}
